import { render, staticRenderFns } from "./myCollection.vue?vue&type=template&id=02c0a39a&scoped=true"
import script from "./myCollection.vue?vue&type=script&lang=js"
export * from "./myCollection.vue?vue&type=script&lang=js"
import style0 from "./myCollection.vue?vue&type=style&index=0&id=02c0a39a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c0a39a",
  null
  
)

export default component.exports